module.exports = __webpack_public_path__ + "img/legalPolicies-privacy.3af3fa87.svg";